module.exports = __webpack_public_path__ + "ath_game_web/img/8.3.8d8c810f.png";